import Grid from '@mui/material/Grid2';
import { useForm } from 'react-hook-form';
import Input from 'components/Common/Input';
import Button from 'components/Common/Button';
import { zodResolver } from '@hookform/resolvers/zod';
import { useCloneAgent } from 'apis/business/agent/hook';
import { AgentCloneRequest } from 'apis/business/agent/types';
import { Typography, InputAdornment, Box } from '@mui/material';
import { agentCloneSchema } from 'utils/schema/validator/AgentCloneValidation';

export default function SelectAgentForm() {
  const { mutateAsync: cloneAgent, isPending } = useCloneAgent();
  const { control, handleSubmit } = useForm<AgentCloneRequest>({
    mode: 'onChange',
    resolver: zodResolver(agentCloneSchema)
  });

  const handleCloneAgent = async (data: AgentCloneRequest) => {
    let websiteName: string;
    if (data?.website_url) {
      websiteName = new URL(data.website_url).hostname;
      localStorage.setItem('configuringAgent', 'true');
    } else {
      localStorage.setItem('configuringAgent', 'withoutWebUrl');
    }
    cloneAgent({ ...data, website_name: websiteName! });
  };

  return (
    <Box component='form' bgcolor='white' p={3} borderRadius={2}>
      <Typography variant='h3' fontSize={16} mb={2} fontWeight={600}>
        Quick Assistant Setup
      </Typography>
      <Grid container spacing={1} mb={3}>
        <Grid size={12}>
          <Typography mb={1} fontSize={14} fontWeight={400}>
            Agent Name
          </Typography>
          <Input name='name' size='small' control={control} fullWidth required />
          <Typography color='secondary' mb={1} fontWeight={400} fontSize={12}>
            What name will your assistant go by
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography mb={1} fontWeight={400} fontSize={14}>
            Link Business Website
          </Typography>
          <Input
            name='website_url'
            size='small'
            control={control}
            slotProps={{
              input: {
                startAdornment: <InputAdornment position='start'>https://</InputAdornment>
              }
            }}
            fullWidth
          />
          <Typography color='secondary' fontSize={12}>
            Connect website so bot understands your services.
          </Typography>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '40px'
        }}
      >
        <Button
          variant='contained'
          color='primary'
          type='submit'
          isPending={isPending}
          onClick={handleSubmit(handleCloneAgent)}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
}
